import { useRef, useState } from 'react';

import { getContext, isContextAvailable } from '@/miniappContext';

import useMount from './useMount';

const useOpen = (callback?: () => void) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const [state, setState] = useState(false);

  useMount(() => {
    if (!isContextAvailable()) return;
    return getContext().handlers.onOpen(() => {
      setState(true);
      if (callbackRef.current) {
        callbackRef.current();
      }
    });
  });

  return state;
};

export default useOpen;
